import React, { useEffect, useState, } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import "./Customization.css"
import 'react-accessible-accordion/dist/fancy-example.css';
// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    CardTitle,
    Label,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    Spinner,
    TabPane,
} from "reactstrap";
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemState,
} from 'react-accessible-accordion';
import Switch from "react-bootstrap-switch";
import Select, { components } from "react-select";

import ImageUpload from "./UploadImage.js";
import ReactTooltip from "react-tooltip";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";

const DragHandle = SortableHandle(() => <FontAwesomeIcon
    icon={faGripVertical} title="Reorder Section"
/>);

const SortableParentDiv = SortableContainer(({ children }) =>
    <div className="parent-div">
        {children}
    </div>
)

const SortableChildDiv = SortableElement(({ children }) =>
    <div className="child-div">
        {children}
    </div>
)

const ConfigFormComponent = (props) => {
    var element = [];
    let divElements = [];
    const [showRemove, setShowRemove] = useState(true);
    const [newObjectKey, setNewObjectKey] = useState(""); // For multi-input-object
    var elementName = props.elementname;
    var elementId = props.elementname;
    var elementDesign = props.data;
    const [tagInput, setTagInput] = useState('');
    const [multiTagInputs, setMultiTagInputs] = useState({});

    var elementType = elementDesign.type;
    var helpText = elementDesign.helptext ? elementDesign.helptext : "";


    if (elementDesign.source && elementDesign.source == "category_list") {
        elementType = "enum";
        elementDesign.type_items = props.categories;
    }
    if (elementDesign.source && elementDesign.source == "filter_list") {
        elementType = "enum";
    }
    if (elementDesign.source && elementDesign.source == "language_list") {
        elementType = "enum";
    }
    if (elementDesign.source && elementDesign.source == "premium_plans_list") {
        elementType = "enum";
    }
    if (elementDesign.source && elementDesign.source == "config_list") {
        elementType = "enum";
    }
    if (elementDesign.type && elementDesign.type == "resource_list") {
        elementType = "enum"; // Treat as enum for rendering Select
        // Options will be dynamically populated
    }

    if (props.grandparent != "") {
        elementName =
            props.subparent +
            "[" +
            props.parent +
            "]" +
            "[" +
            props.elementname +
            "]";
        elementId =
            props.subparent + ":" + props.parent + ":" + props.elementname;
    } else if (props.subparent != "") {
        elementName = props.parent + "[" + props.elementname + "]";
        elementId = props.parent + ":" + props.elementname;
    }


    const arrayMove = (arr, from, to) => {
        const slicedArray = arr.slice();
        slicedArray.splice(
            to < 0 ? arr.length + to : to,
            0,
            slicedArray.splice(from, 1)[0]
        );
        return slicedArray;
    }
    const onSortEnd = ({ oldIndex, newIndex, event, target }) => {
        if (target && target.tagName === 'INPUT') {
            return;
        }
        if (target && target.className && target.className.includes('react-select')) {
            return;
        }

        let currentValue1 = currentValue();

        let newValue = arrayMove(currentValue1, oldIndex, newIndex)

        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.subparent]: {
                        ...props.currentTabConfig[props.subparent],
                        [props.parent]: {
                            ...props.currentTabConfig[props.subparent][
                            props.parent
                            ],
                            [props.elementname]: newValue,
                        },
                    },
                });
                //props.currentTabConfig[props.subparent][props.parent][props.elementname].push(element);
            } else if (props.subparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.parent]: {
                        ...props.currentTabConfig[props.parent],
                        [props.elementname]: newValue,
                    },
                });
            } else {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.elementname]: newValue,
                });

            }
        }
        if (oldIndex !== newIndex) {
            toast.success("Section Reordered")
        }

    }
    const shouldCancelStart = (event) => {
        // console.log("in current shouldCancelStart: ",event)
        const targetElement = event.target;

        if (targetElement.className.includes('react-select')) {
            // Return true to cancel drag start if the target is an react-select
            return true;
        }

        return false; // Allow sorting for other elements
    }


    const SortableSelect = SortableContainer(Select);

    const SortableMultiValueLabel = SortableHandle((props) => {
        return (
            <components.MultiValueLabel {...props} />
        )
    })

    const SortableMultiValue = SortableElement((props) => {
        const onMouseDown = (e) => {
            e.preventDefault();
            e.stopPropagation();
        };
        const innerProps = { ...props.innerProps, onMouseDown };
        return <components.MultiValue {...props} innerProps={innerProps} />
    });

    const handleChange = (event) => {
        let inputId = [event.target.id].toString();

        let inputValue = event.target.value;
        if (elementDesign?.type === "integer") {
            const parsed = parseInt(inputValue, 10);
            if (String(parsed) === inputValue) {
                inputValue = parsed;
            }
        }

        let parentsArray = inputId.split(":");

        if (parentsArray.length === 3) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]]?.[parentsArray[1]],
                        [parentsArray[2]]: inputValue,
                    },
                },
            });
        } else if (parentsArray.length === 2) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: inputValue,
                },
            });
        } else {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: inputValue,
            });
        }

        props.validateConfigField(inputId, inputValue, elementDesign, "field");
    };


    const handleBlur = (event) => {
        let input_id = [event.target.id];
        let input_value = [event.target.value];
    };

    const handleMultiImageChange = (
        inputId,
        event,
        multiValueElementDesign
    ) => {
        //console.log(inputId);
        //console.log(event.target.value);
        // console.log("Handle Multi Image  change:",inputId,event,multiValueElementDesign);
        let inputValue = event.value;
        let parentsArray = inputId.split(":");
        if (parentsArray.length === 5) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]][
                parentsArray[2]
                ];
            multiInputArray[parentsArray[3]][parentsArray[4]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: multiInputArray,
                    },
                },
            });

            // props.setCurrentTabConfig({
            //   ...props.currentTabConfig,
            //   [parentsArray[0]] : {
            //     ...props.currentTabConfig[parentsArray[0]],
            //     [parentsArray[1]] : {
            //       ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
            //       [parentsArray[2]] : {
            //         ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]],
            //         [parentsArray[3]] : {
            //           ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]][parentsArray[3]],
            //           [parentsArray[4]] : inputValue,
            //         }
            //       }
            //     }
            //   }
            // });
        } else if (parentsArray.length === 4) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]];
            multiInputArray[parentsArray[2]][parentsArray[3]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: multiInputArray,
                },
            });

            // props.setCurrentTabConfig({
            //   ...props.currentTabConfig,
            //   [parentsArray[0]] : {
            //     ...props.currentTabConfig[parentsArray[0]],
            //     [parentsArray[1]] : {
            //       ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
            //       [parentsArray[2]] : {
            //         ...props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]],
            //         [parentsArray[3]] : inputValue,
            //       }
            //     }
            //   }
            // });
        } else {
            let multiInputArray = props.currentTabConfig[parentsArray[0]];
            multiInputArray[parentsArray[1]][parentsArray[2]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: multiInputArray,
            });

            // props.setCurrentTabConfig({
            //   ...props.currentTabConfig,
            //   [parentsArray[0]] : {
            //     ...props.currentTabConfig[parentsArray[0]],
            //     [parentsArray[1]] : {
            //       ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
            //       [parentsArray[2]] : inputValue,
            //     }
            //   }
            // });
        }
        props.validateConfigField(
            inputId,
            inputValue,
            multiValueElementDesign,
            "field"
        );
        //console.log(props.currentTabConfig);
    };

    const handleMultiValueChange = (
        inputId,
        event,
        multiValueElementDesign
    ) => {
        event.preventDefault();

        let inputValue = event.target.value;
        if (multiValueElementDesign.type === "integer") {
            const parsed = parseInt(inputValue, 10);
            if (String(parsed) === inputValue) {
                inputValue = parsed;
            }
        }

        let parentsArray = inputId.split(":");

        if (parentsArray.length === 5) {
            let multiInputArray = props.currentTabConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]];
            multiInputArray[parentsArray[3]][parentsArray[4]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
                        [parentsArray[2]]: multiInputArray,
                    },
                },
            });
        } else if (parentsArray.length === 4) {
            let multiInputArray = props.currentTabConfig[parentsArray[0]][parentsArray[1]];
            multiInputArray[parentsArray[2]][parentsArray[3]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: multiInputArray,
                },
            });
        } else {
            let multiInputArray = props.currentTabConfig[parentsArray[0]];
            multiInputArray[parentsArray[1]][parentsArray[2]] = inputValue;

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: multiInputArray,
            });
        }

        props.validateConfigField(
            inputId,
            inputValue,
            multiValueElementDesign,
            "field"
        );
    };

    const handleMultiValueEnumChange = (
        inputId,
        inputValue,
        multiValueEnumDesign
    ) => {
        //let inputValue = event.target.value;
        const parentsArray = inputId.split(":");
        const changedFieldKey = parentsArray[parentsArray.length - 1];
        const elementDesign = props.data;

        // Create a deep copy to avoid direct state mutation.
        const newConfig = JSON.parse(JSON.stringify(props.currentTabConfig));

        let itemToUpdate;

        if (parentsArray.length >= 3) { // It's a multi-input field
            if (parentsArray.length === 5) {
                itemToUpdate = newConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]][parentsArray[3]];
            } else if (parentsArray.length === 4) {
                itemToUpdate = newConfig[parentsArray[0]][parentsArray[1]][parentsArray[2]];
            } else { // length is 3
                itemToUpdate = newConfig[parentsArray[0]][parentsArray[1]];
            }

            // 1. Update the changed field's value
            itemToUpdate[changedFieldKey] = inputValue ? inputValue.value : "";
            if (multiValueEnumDesign.dependent_field) {
                itemToUpdate[multiValueEnumDesign.dependent_field] = inputValue ? inputValue.label : "";
            }

            // 2. Reset dependent (child) fields
            const itemSchema = elementDesign.type_items[0];
            for (const fieldKey in itemSchema) {
                if (fieldKey === changedFieldKey) continue;

                const fieldConfig = itemSchema[fieldKey];

                // Reset Level 2 if its Level 1 parent changed
                if (fieldConfig.source === 'parent_lookup' && fieldConfig.lookup_field === changedFieldKey) {
                    itemToUpdate[fieldKey] = fieldConfig.default !== undefined ? fieldConfig.default : "";
                }

                // Reset Level 3 if its Level 1 or Level 2 parent changed
                if (fieldConfig.source === 'child_lookup' && (fieldConfig.lookup_field === changedFieldKey || fieldConfig.source_field === changedFieldKey)) {
                    itemToUpdate[fieldKey] = fieldConfig.default !== undefined ? fieldConfig.default : [];
                }
            }

            // 3. Update state
            props.setCurrentTabConfig(newConfig);

        } else {
            // This should not be reached for multi-input fields, but as a fallback:
            if (parentsArray.length === 2) {
                newConfig[parentsArray[0]][parentsArray[1]] = inputValue.value;
            } else {
                newConfig[parentsArray[0]] = inputValue.value;
            }
            props.setCurrentTabConfig(newConfig);
        }

        props.validateConfigField(
            inputId,
            inputValue ? inputValue.value : "",
            multiValueEnumDesign
        );
    };

    const handleEnumChange = (inputId, inputValue) => {
        // console.log("inputId",inputId);
        // console.log("inputValue",inputValue);
        // console.log(elementDesign);

        let parentsArray = inputId.split(":");

        // console.log("parentsArray",parentsArray);

        if (parentsArray.length === 3 && props.currentTabConfig && props.currentTabConfig[parentsArray[0]]) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: inputValue.value,
                    },
                },
            });
        } else if (parentsArray.length === 2) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: inputValue.value,
                },
            });
        } else {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: inputValue.value,
            });

        }

        props.validateConfigField(inputId, inputValue.value, elementDesign);
        //console.log(props.currentTabConfig);
    };

    const currentEnumValue = () => {
        let value;
        let savedvalue = "";

        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                if (props.currentTabConfig[props.subparent] && props.currentTabConfig[props.subparent][props.parent]) {
                    savedvalue =
                        props.currentTabConfig[props.subparent][props.parent][props.elementname];
                }
            } else if (props.subparent != "") {
                if (props.currentTabConfig[props.parent]) {
                    savedvalue =
                        props.currentTabConfig[props.parent][props.elementname];
                }
            } else {
                savedvalue = props.currentTabConfig[props.elementname];
            }
        }

        if (savedvalue === undefined && elementDesign.default !== undefined) {
            savedvalue = elementDesign.default;
        }

        const stringSavedValue = String(savedvalue);

        let effectiveOptions = [];
        if (elementDesign.type === "resource_list" && props.resourceList && props.resourceList[elementDesign.name]) {
            effectiveOptions = [
                { value: "", label: "Empty" },
                ...props.resourceList[elementDesign.name].map(item => ({
                    value: String(item.key),
                    label: item.label
                }))
            ];
        } else if (elementDesign.source && ["category_list", "filter_list", "language_list", "premium_plans_list", "config_list"].includes(elementDesign.source) && Array.isArray(elementDesign.type_items)) {
            effectiveOptions = elementDesign.type_items.map(item => ({ ...item, value: String(item.value) }));
        } else if (Array.isArray(elementDesign.type_items)) { // General enum with predefined items
            effectiveOptions = elementDesign.type_items.map(item => ({ ...item, value: String(item.value) }));
        }

        if (effectiveOptions.length > 0) {
            value = effectiveOptions.find(option => option.value === stringSavedValue);
        }
        return value;
    };

    const handleMultiEnumChange = (inputId, inputValue) => {
        // console.log(inputId);
        // console.log(inputValue);
        // console.log(elementDesign);
        let saveValue = [];
        // console.log("input value ", inputValue)
        if (inputValue && inputValue.length) {
            inputValue.forEach(function (saveddetails) {
                saveValue.push(saveddetails.value);
            });
        }


        let parentsArray = inputId.split(":");
        // if(parentsArray.length === 4){
        //     let existingArray = [
        //         ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],   
        //     ] 
        //     existingArray[parentsArray[2]][parentsArray[3]]=saveValue
        //     props.setCurrentTabConfig({
        //         ...props.currentTabConfig,
        //         [parentsArray[0]]: {
        //             ...props.currentTabConfig[parentsArray[0]],
        //             [parentsArray[1]]: existingArray
        //         },
        //     });
        // }else
        if (parentsArray.length === 3) {
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: saveValue,
                    },
                },
            });
        } else if (parentsArray.length === 2) {
            // console.log("two")
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: saveValue,
                },
            });
        } else {
            // console.log()
            // console.log("input",parentsArray.length)
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: saveValue,
            });
        }
        //console.log(props.currentTabConfig);
    };

    const currentMultiEnumValue = () => {
        let value = [];
        let savedvalue = [];
        // console.log(props.subparent);
        // console.log(props.parent)
        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                // console.log("input grandparent")
                savedvalue =
                    props?.currentTabConfig?.[props.subparent]?.[props.parent]?.[
                    props.elementname
                    ];


                // console.log("input savedvalue",savedvalue)
            } else if (props.subparent != "") {
                //console.log(props.currentTabConfig[props.parent][props.elementname]);
                savedvalue = props?.currentTabConfig?.[props.parent]?.[props.elementname];
            } else {
                //console.log(props.currentTabConfig[props.elementname]);
                savedvalue = props.currentTabConfig[props.elementname];
            }
        }
        // console.log("input elementDesign", elementDesign)

        if (Array.isArray(savedvalue) && savedvalue.length && elementDesign?.type_items) {
            savedvalue.forEach(function (saveddetails) {
                elementDesign.type_items.forEach(function (sdetails) {
                    if (sdetails.value == saveddetails) {
                        value.push(sdetails);
                    }
                });
            });
        }
        // console.log("input values", value)
        return value;
    };
    // const currentMultiEnumArrayValue = (index,keyname,items) => {
    //     let value = [];
    //     let savedvalue = [];
    //     if (props.currentTabConfig) {
    //         if (props.grandparent != "") {
    //             savedvalue =
    //                 props.currentTabConfig[props.subparent][props.parent][props.elementname][index][keyname];
    //         } else if (props.subparent != "") {
    //             savedvalue =
    //                 props.currentTabConfig[props.parent][props.elementname][index][keyname];
    //         } else {
    //             savedvalue = props.currentTabConfig[props.elementname][index][keyname];
    //         }
    //     }
    //     if (savedvalue && savedvalue.length &&  items) {
    //         savedvalue.forEach(function (saveddetails) {
    //            items.forEach(function (sdetails) {
    //                 if (sdetails.value == saveddetails) {
    //                     value.push(sdetails);
    //                 }
    //             });
    //         });
    //     }
    //     return value;
    // };

    const currentValue = () => {
        let value;
        // console.log("currentValue",props.currentTabConfig);
        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                if (props.currentTabConfig[props.subparent] && props.currentTabConfig[props.subparent][props.parent]) {
                    value =
                        props.currentTabConfig[props.subparent][props.parent][
                        props.elementname
                        ];
                }
            } else if (props.subparent != "") {
                if (props.currentTabConfig[props.parent]) {
                    value = props.currentTabConfig[props.parent][props.elementname];
                }
            } else {
                value = props.currentTabConfig[props.elementname];
            }
        }

        if (elementDesign.type === 'integer' && value !== undefined && value !== null && value !== '') {
            value = Number(value);
        }

        return value;
    };

    const removeMultiInputValueElement = (indexid) => {
        let removeindex = indexid - 1;
        let elementValue = currentValue();
        elementValue.splice(removeindex, 1);
        //delete elementValue[removeindex];
        //console.log(elementValue);

        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.subparent]: {
                        ...props.currentTabConfig[props.subparent],
                        [props.parent]: {
                            ...props.currentTabConfig[props.subparent][
                            props.parent
                            ],
                            [props.elementname]: elementValue,
                        },
                    },
                });
                //props.currentTabConfig[props.subparent][props.parent][props.elementname].push(element);
            } else if (props.subparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.parent]: {
                        ...props.currentTabConfig[props.parent],
                        [props.elementname]: elementValue,
                    },
                });
            } else {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.elementname]: elementValue,
                });
            }
        }

        //console.log(props.currentTabConfig);
    };

    const addMultiInputValueElement = (indexid, element) => {
        let elementValue;
        let currValue = [];
        currValue = currentValue();
        if (currValue && currValue.length) {
            elementValue = currValue;
        } else {
            //elementValue = {};
            elementValue = [];
        }
        //elementValue[indexid] = element;

        elementValue.push(element);
        //console.log(elementValue);
        //console.log(props.currentTabConfig);
        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.subparent]: {
                        ...props.currentTabConfig[props.subparent],
                        [props.parent]: {
                            ...props.currentTabConfig[props.subparent][
                            props.parent
                            ],
                            [props.elementname]: elementValue,
                        },
                    },
                });
                //props.currentTabConfig[props.subparent][props.parent][props.elementname].push(element);
            } else if (props.subparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.parent]: {
                        ...props.currentTabConfig[props.parent],
                        [props.elementname]: elementValue,
                    },
                });
            } else {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.elementname]: elementValue,
                });

                props.setFieldStates({
                    ...props.fieldStates,
                    ['error_' + props.elementname]: 'has-success',
                    ['error_message_' + props.elementname]: ''
                });
            }
        }
        //console.log(props.currentTabConfig);
    };

    const addMultiInputObjectValueElement = () => {
        if (!newObjectKey.trim()) {
            toast.error(`Please provide a key for the new ${elementDesign.label} item.`);
            return;
        }

        let currentObject = currentValue() || {};
        if (currentObject.hasOwnProperty(newObjectKey)) {
            toast.error(`An item with key "${newObjectKey}" already exists for ${elementDesign.label}.`);
            return;
        }

        const itemSchema = elementDesign.type_items; // Schema for the fields within the new object
        let newElement = {};

        const buildDefaultItemRecursive = (schema, currentLevel) => {
            for (const fieldKey in schema) {
                const fieldConfig = schema[fieldKey];
                if (fieldConfig.items && typeof fieldConfig.items === 'object' && !Array.isArray(fieldConfig.items)) {
                    currentLevel[fieldKey] = {};
                    buildDefaultItemRecursive(fieldConfig.items, currentLevel[fieldKey]);
                } else {
                    currentLevel[fieldKey] = fieldConfig.default !== undefined ? fieldConfig.default : "";
                    if (fieldConfig.type === 'boolean' && fieldConfig.default === undefined) {
                        currentLevel[fieldKey] = false;
                    } else if (fieldConfig.type === 'multi-input' && fieldConfig.default === undefined) {
                        currentLevel[fieldKey] = [];
                    } else if (fieldConfig.type === 'multi-input-object' && fieldConfig.default === undefined) {
                        currentLevel[fieldKey] = {};
                    }
                }
            }
        };

        buildDefaultItemRecursive(itemSchema, newElement);

        // If the action_key_field is part of the item structure, set it.
        if (elementDesign.action_key_field && newElement.hasOwnProperty(elementDesign.action_key_field)) {
            newElement[elementDesign.action_key_field] = newObjectKey;
        }


        const updatedObject = { ...currentObject, [newObjectKey]: newElement };

        if (props.grandparent !== "") {
            props.setCurrentTabConfig(prevConfig => ({
                ...prevConfig,
                [props.subparent]: { ...prevConfig[props.subparent], [props.parent]: { ...prevConfig[props.subparent][props.parent], [props.elementname]: updatedObject } }
            }));
        } else if (props.subparent !== "") {
            props.setCurrentTabConfig(prevConfig => ({
                ...prevConfig,
                [props.parent]: { ...prevConfig[props.parent], [props.elementname]: updatedObject }
            }));
        } else {
            props.setCurrentTabConfig(prevConfig => ({ ...prevConfig, [props.elementname]: updatedObject }));
        }
        setNewObjectKey(""); // Reset the input for the next key
    };

    const removeMultiInputObjectValueElement = (keyToRemove) => {
        let currentObject = { ...(currentValue() || {}) };
        delete currentObject[keyToRemove];

        // Update state similar to addMultiInputObjectValueElement
        // This part needs to be carefully implemented based on how setCurrentTabConfig is structured
        // For brevity, assuming a similar update pattern as addMultiInputObjectValueElement
        if (props.grandparent !== "") { props.setCurrentTabConfig(prevConfig => ({ ...prevConfig, [props.subparent]: { ...prevConfig[props.subparent], [props.parent]: { ...prevConfig[props.subparent][props.parent], [props.elementname]: currentObject } } })); } else if (props.subparent !== "") { props.setCurrentTabConfig(prevConfig => ({ ...prevConfig, [props.parent]: { ...prevConfig[props.parent], [props.elementname]: currentObject } })); } else { props.setCurrentTabConfig(prevConfig => ({ ...prevConfig, [props.elementname]: currentObject })); }
    };

    const multiInputValue = (index, keyname) => {
        // console.log(index);
        // console.log(keyname);
        // console.log("Multi Input Value:",index,keyname);
        let value;
        if (props.currentTabConfig) {
            if (
                props.grandparent != "" &&
                props.currentTabConfig[props.subparent][props.parent][
                props.elementname
                ]
            ) {
                value =
                    props.currentTabConfig[props.subparent][props.parent][
                    props.elementname
                    ][index][keyname];
            } else if (
                props.subparent != "" &&
                props.currentTabConfig[props.parent][props.elementname]
            ) {
                value =
                    props.currentTabConfig[props.parent][props.elementname][
                    index
                    ][keyname];
            } else {
                if (props.currentTabConfig[props.elementname]) {
                    value =
                        props.currentTabConfig[props.elementname][index][
                        keyname
                        ];
                }
            }
        }
        // console.log(elementDesign);
        if (value === undefined && elementDesign["type_items"][0][keyname]?.default !== undefined) {
            value = elementDesign["type_items"][0][keyname].default;
        }

        // Convert to number if the specific field's type is integer and the value is not null or undefined or empty string
        const fieldSchema = elementDesign["type_items"][0][keyname];
        if (fieldSchema && fieldSchema.type === 'integer' && value !== undefined && value !== null && value !== '') {
            value = Number(value);
        }
        // console.log(props)
        // console.log("Value:",value);
        return value;
    };

    const multiObjectInputValue = (objectKey, pathArrayOrFieldKey) => {
        let value;
        let currentLevel = currentValue()?.[objectKey];
        const pathArray = Array.isArray(pathArrayOrFieldKey) ? pathArrayOrFieldKey : [pathArrayOrFieldKey];

        if (currentLevel) {
            for (const part of pathArray) {
                if (currentLevel && typeof currentLevel === 'object' && currentLevel.hasOwnProperty(part)) {
                    currentLevel = currentLevel[part];
                } else {
                    currentLevel = undefined;
                    break;
                }
            }
            value = currentLevel;
        }

        // Determine the schema for the specific field to get default values
        let fieldSchemaTraversal = elementDesign.type_items; // schema of the multi-input-object's items
        let finalFieldSchema = null;

        for (let i = 0; i < pathArray.length; i++) {
            const part = pathArray[i];
            if (fieldSchemaTraversal && typeof fieldSchemaTraversal === 'object' && fieldSchemaTraversal[part]) {
                if (i === pathArray.length - 1) { // Last part of the path, this is the target field's schema
                    finalFieldSchema = fieldSchemaTraversal[part];
                } else if (fieldSchemaTraversal[part].items) { // It's a group, traverse into its items
                    fieldSchemaTraversal = fieldSchemaTraversal[part].items;
                } else { // Path is deeper than schema structure or trying to access sub-property of a non-group
                    finalFieldSchema = undefined;
                    break;
                }
            } else {
                finalFieldSchema = undefined;
                break;
            }
        }

        if (value === undefined && finalFieldSchema && finalFieldSchema.default !== undefined) {
            value = finalFieldSchema.default;
        } else if (value === undefined && finalFieldSchema && finalFieldSchema.type === 'boolean') {
            value = false;
        }
        return value;
    };

    const handleMultiObjectValueChange = (inputId, event, fieldSchema) => {
        const parts = inputId.split(':');
        const mainFieldKey = props.elementname; // This is the key of the multi-input-object itself
        const objectKey = parts[parts.indexOf(mainFieldKey) + 1];
        const pathWithinObject = parts.slice(parts.indexOf(objectKey) + 1);

        let inputValue = event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value;

        if (fieldSchema.type === 'integer') {
            const parsed = parseInt(inputValue, 10);
            if (String(parsed) === inputValue) {
                inputValue = parsed;
            }
        }

        let currentOuterObject = JSON.parse(JSON.stringify(currentValue() || {})); // Deep copy

        let tempObject = currentOuterObject;
        if (!tempObject[objectKey]) tempObject[objectKey] = {};
        tempObject = tempObject[objectKey];

        for (let i = 0; i < pathWithinObject.length - 1; i++) {
            if (!tempObject[pathWithinObject[i]]) {
                tempObject[pathWithinObject[i]] = {};
            }
            tempObject = tempObject[pathWithinObject[i]];
        }
        tempObject[pathWithinObject[pathWithinObject.length - 1]] = inputValue;

        // Update state
        if (props.grandparent !== "") {
            props.setCurrentTabConfig(prev => ({
                ...prev,
                [props.subparent]: {
                    ...prev[props.subparent],
                    [props.parent]: {
                        ...prev[props.subparent][props.parent],
                        [mainFieldKey]: currentOuterObject
                    }
                }
            }));
        } else if (props.subparent !== "") {
            props.setCurrentTabConfig(prev => ({
                ...prev,
                [props.parent]: {
                    ...prev[props.parent],
                    [mainFieldKey]: currentOuterObject
                }
            }));
        } else {
            props.setCurrentTabConfig(prev => ({
                ...prev,
                [mainFieldKey]: currentOuterObject
            }));
        }

        props.validateConfigField(inputId, inputValue, fieldSchema, "field");
    };


    const filterDropdownElement = (keyname, items) => {
        let savedvalue = [];
        if (props.currentTabConfig) {
            if (
                props.grandparent != "" &&
                props.currentTabConfig[props.subparent][props.parent][
                props.elementname
                ]
            ) {
                savedvalue =
                    props.currentTabConfig[props.subparent][props.parent][
                    props.elementname
                    ];
            } else if (
                props.subparent != "" &&
                props.currentTabConfig[props.parent][props.elementname]
            ) {
                savedvalue =
                    props.currentTabConfig[props.parent][props.elementname]
            } else {
                if (props.currentTabConfig[props.elementname]) {
                    savedvalue =
                        props.currentTabConfig[props.elementname];
                }
            }
        }
        if (savedvalue === undefined) {
            savedvalue = [];
        }
        let filteredList = [];
        items.forEach(function (itemDetails) {
            let isPresent = false;
            for (let i = 0; i < savedvalue.length; i++) {
                if (itemDetails.value === savedvalue[i][keyname]) {
                    isPresent = true;
                    break;
                }
            }
            if (isPresent === false) {
                filteredList.push(itemDetails);
            }
        });

        return filteredList;
    }

    const multiObjectInputEnumValue = (objectKey, fieldKey, items) => {
        // fieldKey can be a string or an array for nested paths
        let value;
        let savedValue = multiObjectInputValue(objectKey, Array.isArray(fieldKey) ? fieldKey : [fieldKey]);

        if (items && items.length) {
            value = items.find(item => item.value == savedValue);
        }
        return value;
    };

    const handleMultiObjectValueEnumChange = (inputId, selectedValue, fieldSchema) => {
        const parts = inputId.split(':');
        const mainFieldKey = props.elementname; // Key of the multi-input-object
        const objectKey = parts[parts.indexOf(mainFieldKey) + 1];
        const pathWithinObject = parts.slice(parts.indexOf(objectKey) + 1);

        const actualValue = selectedValue ? selectedValue.value : '';

        let currentOuterObject = JSON.parse(JSON.stringify(currentValue() || {})); // Deep copy

        let tempObject = currentOuterObject;
        if (!tempObject[objectKey]) tempObject[objectKey] = {};
        tempObject = tempObject[objectKey];

        for (let i = 0; i < pathWithinObject.length - 1; i++) {
            if (!tempObject[pathWithinObject[i]]) {
                tempObject[pathWithinObject[i]] = {};
            }
            tempObject = tempObject[pathWithinObject[i]];
        }
        tempObject[pathWithinObject[pathWithinObject.length - 1]] = actualValue;

        // Update state
        if (props.grandparent !== "") {
            props.setCurrentTabConfig(prev => ({ ...prev, [props.subparent]: { ...prev[props.subparent], [props.parent]: { ...prev[props.subparent][props.parent], [mainFieldKey]: currentOuterObject } } }));
        } else if (props.subparent !== "") {
            props.setCurrentTabConfig(prev => ({ ...prev, [props.parent]: { ...prev[props.parent], [mainFieldKey]: currentOuterObject } }));
        } else {
            props.setCurrentTabConfig(prev => ({ ...prev, [mainFieldKey]: currentOuterObject }));
        }

        props.validateConfigField(inputId, actualValue, fieldSchema, "field");
    };
    const multiInputEnumValue = (index, keyname, items) => {
        // console.log(index);
        // console.log(keyname);
        // console.log("propsM...",props.currentTabConfig);
        // console.log("propsMMultiInputEnumValue:",index,keyname,items);
        let value;
        let savedvalue = "";
        if (props.currentTabConfig) {
            if (
                props.grandparent != "" &&
                props.currentTabConfig[props.subparent][props.parent][
                props.elementname
                ]
            ) {
                savedvalue =
                    props.currentTabConfig[props.subparent][props.parent][
                    props.elementname
                    ][index][keyname];
            } else if (
                props.subparent != "" &&
                props.currentTabConfig[props.parent][props.elementname]
            ) {
                savedvalue =
                    props.currentTabConfig[props.parent][props.elementname][
                    index
                    ][keyname];
            } else {
                if (props.currentTabConfig[props.elementname]) {
                    savedvalue =
                        props.currentTabConfig[props.elementname][index][
                        keyname
                        ];
                }
            }
        }
        if (savedvalue === undefined && elementDesign["type_items"][0][keyname].default !== undefined) {
            savedvalue = elementDesign["type_items"][0][keyname].default;
        }

        if (items.length) {
            items.forEach(function (itemdetails) {
                if (itemdetails?.value && itemdetails?.value == savedvalue) {
                    value = itemdetails;
                }
            });
        }

        return value;
    };

    const dropDownCheck = (keyname) => {
        let value;
        if (props.currentTabConfig) {
            if (props.grandparent != "" && props.currentTabConfig?.[props.subparent]?.[props.parent]?.[keyname]
            ) {
                value = props.currentTabConfig[props.subparent][props.parent][keyname];
            } else if (props.subparent != "" && props.currentTabConfig?.[props.parent]?.[keyname]
            ) {
                value = props.currentTabConfig[props.parent][keyname];
            } else {
                if (props.currentTabConfig?.[keyname]) {
                    value = props.currentTabConfig[keyname];
                }
            }
        }
        return value;
    }

    const handleMultiValueMultiEnumChange = (
        inputId,
        inputValue,
        multiValueEnumDesign
    ) => {
        //let inputValue = event.target.value;

        let saveValue = [];
        if (inputValue && inputValue.length) {
            inputValue.forEach(function (saveddetails) {
                saveValue.push(saveddetails.value);
            });
        }

        let parentsArray = inputId.split(":");

        if (parentsArray.length === 5) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]][
                parentsArray[2]
                ];
            multiInputArray[parentsArray[3]][parentsArray[4]] =
                saveValue;
            if (multiValueEnumDesign.dependent_field) {
                multiInputArray[parentsArray[3]][
                    multiValueEnumDesign.dependent_field
                ] = saveValue[0]?.label;
            }

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: {
                        ...props.currentTabConfig[parentsArray[0]][
                        parentsArray[1]
                        ],
                        [parentsArray[2]]: multiInputArray,
                    },
                },
            });
        } else if (parentsArray.length === 4) {
            let multiInputArray =
                props.currentTabConfig[parentsArray[0]][parentsArray[1]];
            multiInputArray[parentsArray[2]][parentsArray[3]] =
                saveValue;
            if (multiValueEnumDesign.dependent_field) {
                multiInputArray[parentsArray[2]][
                    multiValueEnumDesign.dependent_field
                ] = saveValue[0]?.label;
            }

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: {
                    ...props.currentTabConfig[parentsArray[0]],
                    [parentsArray[1]]: multiInputArray,
                },
            });
        } else {
            let multiInputArray = props.currentTabConfig[parentsArray[0]];
            multiInputArray[parentsArray[1]][parentsArray[2]] =
                saveValue.value;
            if (multiValueEnumDesign.dependent_field) {
                multiInputArray[parentsArray[1]][
                    multiValueEnumDesign.dependent_field
                ] = saveValue[0]?.label;
            }

            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [parentsArray[0]]: multiInputArray,
            });
        }


        props.validateConfigField(
            inputId,
            saveValue,
            multiValueEnumDesign
        );
    };

    // Reorder handler for multi-select enums nested inside multi-input arrays
    const onNestedMultiSelectSortEnd = (inputId) => ({ oldIndex, newIndex }) => {
        if (oldIndex === newIndex) return;
        const parentsArray = inputId.split(":");

        if (parentsArray.length === 5) {
            // subparent, parent, elementName, index, fieldKey
            const [sp, p, el, idx, field] = parentsArray;
            const multiInputArray = (props.currentTabConfig?.[sp]?.[p]?.[el]) || [];
            const currentValues = (multiInputArray?.[idx]?.[field]) || [];
            const newValues = arrayMove(currentValues, oldIndex, newIndex);

            multiInputArray[idx][field] = newValues;
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [sp]: {
                    ...props.currentTabConfig[sp],
                    [p]: {
                        ...props.currentTabConfig[sp][p],
                        [el]: multiInputArray,
                    },
                },
            });
        } else if (parentsArray.length === 4) {
            // parent, elementName, index, fieldKey
            const [p, el, idx, field] = parentsArray;
            const multiInputArray = (props.currentTabConfig?.[p]?.[el]) || [];
            const currentValues = (multiInputArray?.[idx]?.[field]) || [];
            const newValues = arrayMove(currentValues, oldIndex, newIndex);

            multiInputArray[idx][field] = newValues;
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [p]: {
                    ...props.currentTabConfig[p],
                    [el]: multiInputArray,
                },
            });
        } else if (parentsArray.length === 3) {
            // elementName, index, fieldKey
            const [el, idx, field] = parentsArray;
            const multiInputArray = (props.currentTabConfig?.[el]) || [];
            const currentValues = (multiInputArray?.[idx]?.[field]) || [];
            const newValues = arrayMove(currentValues, oldIndex, newIndex);

            multiInputArray[idx][field] = newValues;
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [el]: multiInputArray,
            });
        }
    };

    // Helpers for multi-select enums inside multi-input-object
    const multiObjectInputMultiEnumValue = (objectKey, fieldKey, items) => {
        const saved = multiObjectInputValue(objectKey, Array.isArray(fieldKey) ? fieldKey : [fieldKey]) || [];
        if (!Array.isArray(saved) || !items) return [];
        const values = [];
        saved.forEach((v) => {
            const found = items.find((opt) => JSON.stringify(opt.value) === JSON.stringify(v));
            if (found) values.push(found);
        });
        return values;
    };

    const handleMultiObjectValueMultiEnumChange = (inputId, selectedOptions, fieldSchema) => {
        const parts = inputId.split(":");
        const mainFieldKey = props.elementname;
        const objectKey = parts[parts.indexOf(mainFieldKey) + 1];
        const pathWithinObject = parts.slice(parts.indexOf(objectKey) + 1);

        const saveValue = Array.isArray(selectedOptions) ? selectedOptions.map(o => o.value) : [];

        let currentOuterObject = JSON.parse(JSON.stringify(currentValue() || {}));

        let tempObject = currentOuterObject;
        if (!tempObject[objectKey]) tempObject[objectKey] = {};
        tempObject = tempObject[objectKey];

        for (let i = 0; i < pathWithinObject.length - 1; i++) {
            if (!tempObject[pathWithinObject[i]]) {
                tempObject[pathWithinObject[i]] = {};
            }
            tempObject = tempObject[pathWithinObject[i]];
        }
        tempObject[pathWithinObject[pathWithinObject.length - 1]] = saveValue;

        if (props.grandparent !== "") {
            props.setCurrentTabConfig(prev => ({ ...prev, [props.subparent]: { ...prev[props.subparent], [props.parent]: { ...prev[props.subparent][props.parent], [mainFieldKey]: currentOuterObject } } }));
        } else if (props.subparent !== "") {
            props.setCurrentTabConfig(prev => ({ ...prev, [props.parent]: { ...prev[props.parent], [mainFieldKey]: currentOuterObject } }));
        } else {
            props.setCurrentTabConfig(prev => ({ ...prev, [mainFieldKey]: currentOuterObject }));
        }

        props.validateConfigField(inputId, saveValue, fieldSchema);
    };

    const onObjectMultiSelectSortEnd = (inputId) => ({ oldIndex, newIndex }) => {
        if (oldIndex === newIndex) return;
        const parts = inputId.split(":");
        const mainFieldKey = props.elementname;
        const objectKey = parts[parts.indexOf(mainFieldKey) + 1];
        const pathWithinObject = parts.slice(parts.indexOf(objectKey) + 1);

        let currentOuterObject = JSON.parse(JSON.stringify(currentValue() || {}));
        let tempObject = currentOuterObject;
        if (!tempObject[objectKey]) tempObject[objectKey] = {};
        tempObject = tempObject[objectKey];

        for (let i = 0; i < pathWithinObject.length - 1; i++) {
            if (!tempObject[pathWithinObject[i]]) {
                tempObject[pathWithinObject[i]] = {};
            }
            tempObject = tempObject[pathWithinObject[i]];
        }
        const leafKey = pathWithinObject[pathWithinObject.length - 1];
        const currentValues = Array.isArray(tempObject[leafKey]) ? tempObject[leafKey] : [];
        const newValues = arrayMove(currentValues, oldIndex, newIndex);
        tempObject[leafKey] = newValues;

        if (props.grandparent !== "") {
            props.setCurrentTabConfig(prev => ({ ...prev, [props.subparent]: { ...prev[props.subparent], [props.parent]: { ...prev[props.subparent][props.parent], [mainFieldKey]: currentOuterObject } } }));
        } else if (props.subparent !== "") {
            props.setCurrentTabConfig(prev => ({ ...prev, [props.parent]: { ...prev[props.parent], [mainFieldKey]: currentOuterObject } }));
        } else {
            props.setCurrentTabConfig(prev => ({ ...prev, [mainFieldKey]: currentOuterObject }));
        }
    };

    const multiInputMultiEnumValue = (index, keyname, items) => {
        let value = [];
        let savedvalue = [];
        if (props.currentTabConfig) {
            if (
                props.grandparent != "" &&
                props.currentTabConfig[props.subparent][props.parent][
                props.elementname
                ]
            ) {
                savedvalue =
                    props.currentTabConfig[props.subparent][props.parent][
                    props.elementname
                    ][index][keyname];
            } else if (
                props.subparent != "" &&
                props.currentTabConfig[props.parent][props.elementname]
            ) {
                savedvalue =
                    props.currentTabConfig[props.parent][props.elementname][
                    index
                    ][keyname];
            } else {
                if (props.currentTabConfig[props.elementname]) {
                    savedvalue =
                        props.currentTabConfig[props.elementname][index][
                        keyname
                        ];
                }
            }
        }


        if (savedvalue === undefined && elementDesign["type_items"][0][keyname].default !== undefined) {
            savedvalue = elementDesign["type_items"][0][keyname].default;
        }

        if (Array.isArray(savedvalue) && savedvalue?.length && items) {
            savedvalue.forEach(function (saveddetails) {
                items.forEach(function (sdetails) {
                    if (JSON.stringify(sdetails.value) === JSON.stringify(saveddetails)) {
                        value.push(sdetails);
                    }
                });
            });
        }
        return value;
    };

    const duplicateMultiInputValueElement = (indexToDuplicate) => {
        let elementValue = currentValue();
        if (indexToDuplicate < 0 || indexToDuplicate >= elementValue.length) {
            return;
        }

        const itemToDuplicate = elementValue[indexToDuplicate];
        const newItem = JSON.parse(JSON.stringify(itemToDuplicate));

        elementValue.splice(indexToDuplicate + 1, 0, newItem);

        if (props.currentTabConfig) {
            if (props.grandparent != "") {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.subparent]: {
                        ...props.currentTabConfig[props.subparent],
                        [props.parent]: {
                            ...props.currentTabConfig[props.subparent][
                            props.parent
                            ],
                            [props.elementname]: elementValue,
                        },
                    },
                });
            } else if (props.subparent != "") {
                props.setCurrentTabConfig({ ...props.currentTabConfig, [props.parent]: { ...props.currentTabConfig[props.parent], [props.elementname]: elementValue, }, });
            } else {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [props.elementname]: elementValue,
                });
            }
        }
        toast.success("Item Duplicated");
    };
    const duplicateMultiInputObjectValueElement = (keyToDuplicate) => {
        let currentObject = currentValue() || {};
        if (!currentObject.hasOwnProperty(keyToDuplicate)) {
            return;
        }

        const itemToDuplicate = currentObject[keyToDuplicate];
        const newItem = JSON.parse(JSON.stringify(itemToDuplicate));

        let newKey = `${keyToDuplicate}-copy`;
        let counter = 1;
        while (currentObject.hasOwnProperty(newKey)) {
            newKey = `${keyToDuplicate}-copy-${counter++}`;
        }

        if (elementDesign.action_key_field && newItem.hasOwnProperty(elementDesign.action_key_field)) {
            newItem[elementDesign.action_key_field] = newKey;
        }

        const newObject = {};
        const keys = Object.keys(currentObject);
        for (const key of keys) {
            newObject[key] = currentObject[key];
            if (key === keyToDuplicate) {
                newObject[newKey] = newItem;
            }
        }

        if (props.grandparent !== "") {
            props.setCurrentTabConfig(prev => ({ ...prev, [props.subparent]: { ...prev[props.subparent], [props.parent]: { ...prev[props.subparent][props.parent], [props.elementname]: newObject } } }));
        } else if (props.subparent !== "") {
            props.setCurrentTabConfig(prev => ({ ...prev, [props.parent]: { ...prev[props.parent], [props.elementname]: newObject } }));
        } else {
            props.setCurrentTabConfig(prev => ({ ...prev, [props.elementname]: newObject }));
        }
        toast.success("Item Duplicated");
    };
    const updateTags = (newTags) => {
        let parentsArray = elementId.split(":");
        if (props.currentTabConfig) {
            if (parentsArray.length === 3) {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [parentsArray[0]]: {
                        ...props.currentTabConfig[parentsArray[0]],
                        [parentsArray[1]]: {
                            ...props.currentTabConfig[parentsArray[0]][parentsArray[1]],
                            [parentsArray[2]]: newTags,
                        },
                    },
                });
            } else if (parentsArray.length === 2) {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [parentsArray[0]]: {
                        ...props.currentTabConfig[parentsArray[0]],
                        [parentsArray[1]]: newTags,
                    },
                });
            } else {
                props.setCurrentTabConfig({
                    ...props.currentTabConfig,
                    [parentsArray[0]]: newTags,
                });
            }
        }
    };

    const handleTagInputKeyDown = (event) => {
        if (event.key === 'Enter' && tagInput.trim() !== '') {
            event.preventDefault();
            const currentTags = currentValue() || [];
            let newTag = tagInput.trim();

            if (elementDesign.value_type === 'integer') {
                if (!/^\d+$/.test(newTag)) {
                    toast.error("Please enter a valid integer.");
                    return;
                }
                newTag = parseInt(newTag, 10);
            }

            if (!currentTags.includes(newTag)) {
                const newTags = [...currentTags, newTag];
                updateTags(newTags);
            } else {
                toast.warn(`Tag "${newTag}" already exists.`);
            }
            setTagInput('');
        }
    };

    const handleRemoveTag = (indexToRemove) => {
        const newTags = (currentValue() || []).filter((_, index) => index !== indexToRemove);
        updateTags(newTags);
    };
    // Helper: read current tags for a multi-input / multi-input-object field by inputId
    const getMultiCurrentTags = (inputId) => {
        if (!props.currentTabConfig) return [];
        const parts = inputId.split(':');

        // If this is a multi-input-object id (contains the main field key), handle like other multi-object helpers
        if (parts.includes(props.elementname)) {
            try {
                const mainFieldKey = props.elementname;
                const objectKey = parts[parts.indexOf(mainFieldKey) + 1];
                const pathWithinObject = parts.slice(parts.indexOf(objectKey) + 1);

                const base = currentValue() || {};
                let temp = base[objectKey];
                if (!temp) return [];

                for (let i = 0; i < pathWithinObject.length; i++) {
                    if (temp && temp.hasOwnProperty(pathWithinObject[i])) {
                        temp = temp[pathWithinObject[i]];
                    } else {
                        temp = undefined;
                        break;
                    }
                }
                return Array.isArray(temp) ? temp : [];
            } catch (e) {
                return [];
            }
        }

        // Otherwise treat as multi-input (array-based) inputId
        try {
            if (parts.length === 5) {
                // sp, p, el, idx, field
                const [sp, p, el, idx, field] = parts;
                const arr = (props.currentTabConfig?.[sp]?.[p]?.[el]) || [];
                return (arr?.[idx]?.[field]) || [];
            } else if (parts.length === 4) {
                const [p, el, idx, field] = parts;
                const arr = (props.currentTabConfig?.[p]?.[el]) || [];
                return (arr?.[idx]?.[field]) || [];
            } else if (parts.length === 3) {
                const [el, idx, field] = parts;
                const arr = (props.currentTabConfig?.[el]) || [];
                return (arr?.[idx]?.[field]) || [];
            } else {
                return [];
            }
        } catch (e) {
            return [];
        }
    };

    // Update tags for multi-input or multi-input-object fields (inputId defines target)
    const updateMultiTags = (inputId, newTags) => {
        if (!props.currentTabConfig) return;
        const parts = inputId.split(':');

        // multi-input-object: find the main field key and update the object leaf
        if (parts.includes(props.elementname)) {
            const mainFieldKey = props.elementname;
            const objectKey = parts[parts.indexOf(mainFieldKey) + 1];
            const pathWithinObject = parts.slice(parts.indexOf(objectKey) + 1);

            // Deep clone current object, update leaf
            let currentOuterObject = JSON.parse(JSON.stringify(currentValue() || {}));
            if (!currentOuterObject[objectKey]) currentOuterObject[objectKey] = {};
            let temp = currentOuterObject[objectKey];

            for (let i = 0; i < pathWithinObject.length - 1; i++) {
                if (!temp[pathWithinObject[i]]) temp[pathWithinObject[i]] = {};
                temp = temp[pathWithinObject[i]];
            }
            temp[pathWithinObject[pathWithinObject.length - 1]] = newTags;

            if (props.grandparent !== "") {
                props.setCurrentTabConfig(prev => ({ ...prev, [props.subparent]: { ...prev[props.subparent], [props.parent]: { ...prev[props.subparent][props.parent], [mainFieldKey]: currentOuterObject } } }));
            } else if (props.subparent !== "") {
                props.setCurrentTabConfig(prev => ({ ...prev, [props.parent]: { ...prev[props.parent], [mainFieldKey]: currentOuterObject } }));
            } else {
                props.setCurrentTabConfig(prev => ({ ...prev, [mainFieldKey]: currentOuterObject }));
            }
            return;
        }

        // Otherwise handle as multi-input (array based)
        const parentsArray = parts;
        if (parentsArray.length === 5) {
            const [sp, p, el, idx, field] = parentsArray;
            const multiInputArray = JSON.parse(JSON.stringify((props.currentTabConfig?.[sp]?.[p]?.[el]) || []));
            if (!multiInputArray[idx]) multiInputArray[idx] = {};
            multiInputArray[idx][field] = newTags;
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [sp]: {
                    ...props.currentTabConfig[sp],
                    [p]: {
                        ...props.currentTabConfig[sp][p],
                        [el]: multiInputArray,
                    },
                },
            });
        } else if (parentsArray.length === 4) {
            const [p, el, idx, field] = parentsArray;
            const multiInputArray = JSON.parse(JSON.stringify((props.currentTabConfig?.[p]?.[el]) || []));
            if (!multiInputArray[idx]) multiInputArray[idx] = {};
            multiInputArray[idx][field] = newTags;
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [p]: {
                    ...props.currentTabConfig[p],
                    [el]: multiInputArray,
                },
            });
        } else if (parentsArray.length === 3) {
            const [el, idx, field] = parentsArray;
            const multiInputArray = JSON.parse(JSON.stringify((props.currentTabConfig?.[el]) || []));
            if (!multiInputArray[idx]) multiInputArray[idx] = {};
            multiInputArray[idx][field] = newTags;
            props.setCurrentTabConfig({
                ...props.currentTabConfig,
                [el]: multiInputArray,
            });
        } else {
            // Fallback: treat like top-level
            updateTags(newTags);
        }
    };

    // KeyDown handler for multi tag inputs (uses transient multiTagInputs state)
    const handleMultiTagInputKeyDown = (event, inputId, fieldSchema) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            const typed = (multiTagInputs[inputId] || '').trim();
            if (!typed) return;

            let newTag = typed;
            if (fieldSchema && fieldSchema.value_type === 'integer') {
                if (!/^\d+$/.test(newTag)) {
                    toast.error("Please enter a valid integer.");
                    return;
                }
                newTag = parseInt(newTag, 10);
            }

            const currentTags = getMultiCurrentTags(inputId) || [];
            if (!currentTags.includes(newTag)) {
                const newTags = [...currentTags, newTag];
                updateMultiTags(inputId, newTags);
            } else {
                toast.warn(`Tag "${newTag}" already exists.`);
            }

            // clear the transient input
            setMultiTagInputs(prev => ({ ...prev, [inputId]: '' }));
        }
    };

    // Remove a tag for a multi field
    const handleMultiRemoveTag = (inputId, indexToRemove) => {
        const currentTags = getMultiCurrentTags(inputId) || [];
        const newTags = currentTags.filter((_, idx) => idx !== indexToRemove);
        updateMultiTags(inputId, newTags);
    };


    if (elementType == "string") {
        let showField = true;

        if (elementDesign.parent_field && typeof elementDesign.parent_field === 'object') {
            for (let key in elementDesign.parent_field) {
                const allowedValues = elementDesign.parent_field[key]; // e.g., ["web_link"]
                const actualValue = dropDownCheck(key);

                if (!allowedValues.includes(actualValue)) {
                    showField = false;
                    break; // No need to keep checking if one fails
                }
            }
        }

        let displayField = showField ? "" : "none";


        element.push(
            <Row style={{ display: displayField }}>
                <Col sm="6">
                    <div className="designLabel">
                        <small className="text-default">
                            {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                        </small>
                    </div>
                    {helpText != "" ? (
                        <Label className="smLabl-txt">{helpText}</Label>
                    ) : (
                        ""
                    )}
                </Col>
                <Col sm="6">
                    <div className="inptFom1">
                        <FormGroup
                            className={props.fieldStates["error_" + elementId]}
                        >
                            <Input
                                type="text"
                                name={elementName}
                                id={elementId}
                                value={currentValue()}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error">
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }
                                </label>
                            ) : null}
                        </FormGroup>
                    </div>
                </Col>
            </Row>
        );
    } else if (elementType == "boolean") {
        let showField = true;
        if (elementDesign.parent_field && typeof elementDesign.parent_field === 'object') {
            for (let key in elementDesign.parent_field) {
               let allowedValues = elementDesign.parent_field[key];
                if (!Array.isArray(allowedValues)) {
                    allowedValues = [allowedValues];
                }
                const actualValue = dropDownCheck(key);
                if (!allowedValues.includes(actualValue)) {
                    showField = false;
                    break;
                }
            }
        }
        let displayField = showField ? "" : "none";
        element.push(
            <Row>
                <Col sm="6" >
                    <div className="designLabel">
                        <small className="text-default">
                            {elementDesign.label}{props.data.required ? <span className="text-danger"> * </span> : ""}
                        </small>
                    </div>
                    {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                </Col>
                <Col sm="6">
                    <div className="inptFom1">
                        <FormGroup>
                            <Switch
                                name={elementName}
                                offColor="success"
                                offText={<i className="nc-icon nc-simple-remove" />}
                                onColor="success"
                                onText={<i className="nc-icon nc-check-2" />}
                                value={currentValue()}
                                onChange={(value, enabled) =>
                                    handleEnumChange(elementId, { value: enabled })
                                }
                            />{" "}
                        </FormGroup>
                    </div>
                </Col>
            </Row>
        );
    } else if (elementType == "integer") {
        element.push(
            <Row>
                <Col sm="6">
                    <div className="designLabel">
                        <small className="text-default">
                            {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                        </small>
                    </div>
                    {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                </Col>
                <Col sm="6">
                    <div className="inptFom1">
                        <FormGroup
                            className={props.fieldStates["error_" + elementId]}
                        >
                            <Input
                                type="number"
                                name={elementName}
                                id={elementId}
                                value={currentValue()}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error">
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }
                                </label>
                            ) : null}
                        </FormGroup>
                    </div>
                </Col>
            </Row>
        );
    } else if (elementType == "hidden") {
        element.push(
            <Row>
                <Col sm="12">
                    <div className="inptFom1">
                        <FormGroup>
                            <Input
                                type="hidden"
                                name={elementName}
                                id={elementId}
                                value={currentValue()}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </FormGroup>
                    </div>
                </Col>
            </Row>
        );
    } else if (elementType == "hex_color") {
        element.push(
            <Row>
                <Col sm="6">
                    <div className="designLabel">
                        <small className="text-default">
                            {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                        </small>
                    </div>
                    {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                </Col>
                <Col sm="6">
                    <div className="inptFomColr">
                        <div className="clrChng" style={{ display: "inline-block", border: "none", }}>
                            <Input
                                style={{ background: currentValue() }}
                                type="color"
                                name={elementName}
                                id={elementId}
                                value={currentValue()}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </div>
                        <div className="clrTxt" style={{ display: "inline-block" }}>
                            <input
                                //   style={{border:"none" }}
                                type="text"
                                name={elementName}
                                id={elementId}
                                value={currentValue()}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        );
    } else if (elementType == "url") {
        element.push(
            <Row>
                <Col sm="6">
                    <div className="designLabel">
                        <small className="text-default">
                            {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                        </small>
                    </div>
                    {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                </Col>
                <Col sm="6">
                    <div className="inptFom1">
                        <FormGroup
                            className={props?.fieldStates["error_" + elementId]}
                        >
                            <Input
                                type="url"
                                name={elementName}
                                id={elementId}
                                value={currentValue()}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error">
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }
                                </label>
                            ) : null}
                        </FormGroup>
                    </div>
                </Col>
            </Row>
        );
    } else if (elementType == "enum" && elementDesign.type == "array") {
        //console.log(elementName);

        element.push(
            <Row>
                <Col sm="6">
                    <div className="designLabel">
                        <small className="text-default">
                            {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                        </small>
                    </div>
                    {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                </Col>
                <Col sm="6">
                    <div className="inptFom1">
                        <FormGroup
                            className={props.fieldStates["error_" + elementId]}
                        >
                            <SortableSelect
                                useDragHandle
                                axis="xy"
                                onSortEnd={onSortEnd}
                                distance={4}
                                getHelperDimensions={({ node }) => node.getBoundingClientRect()}
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name={elementName}
                                // id={elementId}
                                isMulti="true"
                                hideSelectedOptions={false}
                                value={currentMultiEnumValue()}
                                options={elementDesign.type_items}
                                onChange={(value) =>
                                    handleMultiEnumChange(elementId, value)
                                }
                                components={{
                                    MultiValue: SortableMultiValue,
                                    MultiValueLabel: SortableMultiValueLabel,
                                }}
                                allowSelectAll={true}
                                closeMenuOnSelect={false}
                            />
                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label>
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }
                                </label>
                            ) : null}
                            <div id={elementId} tabIndex="0"></div>
                        </FormGroup>
                    </div>
                </Col>
            </Row>
        );
    } else if (elementType == "enum") {
        let showField = true;

        if (elementDesign.parent_field && typeof elementDesign.parent_field === 'object') {
            for (let key in elementDesign.parent_field) {
                const allowedValues = elementDesign.parent_field[key]; // e.g., ["web_link"]
                const actualValue = dropDownCheck(key);

                if (!allowedValues.includes(actualValue)) {
                    showField = false;
                    break; // No need to keep checking if one fails
                }
            }
        }

        let displayField = showField ? "" : "none";
        element.push(
            <Row style={{ display: displayField }}>
                <Col sm="6">
                    <div className="designLabel">
                        <small className="text-default">
                            {elementDesign.label}{props.data.required ? <span class="text-danger"> * </span> : ""}
                        </small>
                    </div>
                    {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                </Col>
                <Col sm="6">
                    <div className="inptFom1">
                        <FormGroup
                            className={props.fieldStates["error_" + elementId]}>
                            <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name={elementName}
                                id={elementId}
                                value={currentEnumValue()}
                                options={
                                    elementDesign.type === "resource_list" && props.resourceList && props.resourceList[elementDesign.name]
                                        ? [
                                            { value: "", label: "Empty" },
                                            ...props.resourceList[elementDesign.name].map(item => ({
                                                value: item.key,
                                                label: item.label
                                            }))
                                        ]
                                        : elementDesign.type_items
                                }
                                isLoading={elementDesign.type === "resource_list" && props.isLoadingResources}
                                isDisabled={elementDesign.type === "resource_list" && props.isLoadingResources}

                                onChange={(value) =>
                                    handleEnumChange(elementId, value)
                                }
                            />
                            <br></br>
                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error">
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }
                                </label>
                            ) : null}
                            <div id={elementId} tabIndex="0"></div>
                        </FormGroup>
                    </div>
                </Col>
            </Row>
        );
    } else if (elementType == "file_upload") {
        element.push(
            <Row>
                <Col sm="6">
                    <div className="designLabel">
                        <small className="text-default">
                            {elementDesign.label}
                            {elementDesign.size ? (
                                <span>({elementDesign.size})</span>
                            ) : (
                                ""
                            )}{props.data.required ? <span class="text-danger"> * </span> : ""}
                        </small>
                    </div>
                    {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                </Col>
                <Col sm="6">
                    <div className="inptFom1">
                        <FormGroup
                            className={props.fieldStates["error_" + elementId]}>

                            <ImageUpload
                                projectId={props.projectId}
                                imageDetails={elementDesign}
                                elementValue={
                                    props.currentTabConfig ? currentValue() : ""
                                }
                                id={elementId}
                                handleEnumChange={handleEnumChange}
                            />
                            <Input
                                type="hidden"
                                name={elementName}
                                id={elementId}
                                value={currentValue()}
                                onChange={handleChange}
                            />
                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error">
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }
                                </label>
                            ) : null}
                        </FormGroup>
                    </div>
                </Col>
            </Row>
        );
    } else if (elementType == "multi-input") {
        let showField = true;
        if (elementDesign.parent_field && typeof elementDesign.parent_field === 'object') {
            for (let key in elementDesign.parent_field) {
                let allowedValues = elementDesign.parent_field[key];
                if (!Array.isArray(allowedValues)) {
                    allowedValues = [allowedValues];
                }
                const actualValue = dropDownCheck(key);
                if (!allowedValues.includes(actualValue)) {
                    showField = false;
                    break;
                }
            }
        }
        let displayField = showField ? "" : "none";
        //console.log(elementDesign.type_items);
        let multiInputFields = elementDesign.type_items;
        // let multiInputElements = [];
        let defaultElement = {};
        // let divElements = []
        Object.keys(multiInputFields[0]).forEach(function (fieldkey) {
            defaultElement[fieldkey] = multiInputFields[0][fieldkey].default;
        });
        let totalValues = multiInputFields;
        let currValue = [];
        currValue = currentValue();
        // console.log("currentValue",currValue);
        if (!currValue || !currValue.length) {
            totalValues = [];
            //addMultiInputValueElement(0,defaultElement);
        } else {
            totalValues = currValue;
        }

        let nextIndex = 0;
        let divElements = [];
        if (totalValues.length) {
            for (let key = 0; key < totalValues.length; key++) {
                //Object.keys(totalValues).forEach(function(key) {
                let multiInputElements = [];

                multiInputElements.push(
                    <Row>
                        <Col>
                            <b>{nextIndex + 1}</b>
                            <hr></hr>
                        </Col>
                    </Row>
                );
                Object.keys(multiInputFields[0]).forEach(function (fieldkey) {
                    //console.log(multiInputFields[key][fieldkey]);
                    let listField = multiInputFields[0][fieldkey];
                    let listFieldName =
                        elementName + "[" + key + "][" + fieldkey + "]";
                    let listFieldId = elementId + ":" + key + ":" + fieldkey;

                    let listFieldOriginalType = listField.type;
                    let listFieldRenderType = listFieldOriginalType;

                    // Determine the effective render type for the field
                    // Fields with specific sources or types like resource_list/cat_array are rendered as enums (Select dropdowns)
                    if (listField.source && ["category_list", "project_list", "filter_list", "language_list"].includes(listField.source)) {
                        listFieldRenderType = "enum";
                    } else if (listFieldOriginalType === "resource_list" || listFieldOriginalType === "cat_array") {
                        listFieldRenderType = "enum";
                    }

                    // console.log(listField)
                    let showField = true;

                    if (listField.parent_field && typeof listField.parent_field === 'object') {
                        for (let fieldKey in listField.parent_field) {
                            const allowedValues = listField.parent_field[fieldKey]; // array of allowed values
                            const parentValue = multiInputValue(key, fieldKey); // assume this returns the actual config value

                            if (!allowedValues.includes(parentValue)) {
                                showField = false;
                                break; // one mismatch is enough to hide it
                            }
                        }
                    }

                    let displayField = showField ? '' : 'none';

                    //defaultElement[fieldkey] = listField.default;
                    if (listFieldRenderType == "string") {
                        multiInputElements.push(

                            <Row style={{ display: displayField }}>
                                <Col md="6">
                                    <div className="designLabel ">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }
                                        >
                                            <Input
                                                type="text"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error">
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldRenderType == "boolean") {
                        multiInputElements.push(
                            <Row style={{ display: displayField }}>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Switch
                                            name={listFieldName}
                                            offColor="success"
                                            offText={
                                                <i className="nc-icon nc-simple-remove" />
                                            }
                                            onColor="success"
                                            onText={
                                                <i className="nc-icon nc-check-2" />
                                            }
                                            value={multiInputValue(
                                                key,
                                                fieldkey
                                            )}
                                            onChange={(value, enabled) =>
                                                handleMultiValueEnumChange(
                                                    listFieldId,
                                                    { value: enabled },
                                                    listField
                                                )
                                            }
                                        />{" "}
                                    </FormGroup>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldRenderType == "integer") {
                        multiInputElements.push(
                            <Row style={{ display: displayField }}>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }>

                                            <Input
                                                type="number"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error">
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldRenderType == "hidden") {
                        multiInputElements.push(
                            <Row style={{ display: displayField }}>
                                <Col md="6">
                                    <div className="lblName">
                                        <Label >{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFom">
                                        <FormGroup>
                                            <Input
                                                type="hidden"
                                                name={listFieldName}
                                                id={listFieldName}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldRenderType == "hex_color") {
                        multiInputElements.push(
                            <Row style={{ display: displayField }}>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFomColr">
                                        <div className="clrChng" style={{ display: "inline-block", border: "none", }}>

                                            <Input
                                                style={{
                                                    background: multiInputValue(
                                                        key,
                                                        fieldkey
                                                    ),
                                                }}
                                                type="color"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="clrTxt" style={{ display: "inline-block" }}>
                                            <input
                                                //   style={{border:"none" }}
                                                type="text"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                        </div>


                                        {props.fieldStates[
                                            "error_" + listFieldId
                                        ] === "has-danger" ? (
                                            <label className="error" id={props.parent + listFieldId}>
                                                {
                                                    props.fieldStates[
                                                    "error_message_" +
                                                    listFieldId
                                                    ]
                                                }
                                            </label>
                                        ) : null}
                                    </div>

                                </Col>
                            </Row>
                        );
                    //separator for section break
                    // }else if (listFieldRenderType == "separator") {
                    //     multiInputElements.push(
                    //         <Row style={{ display: displayField, width: '100%', marginTop: '15px', marginBottom: '5px' }}>
                    //             <Col md="12">
                    //                 <div className="designLabel">
                    //                     <Label style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#444' }}>
                    //                         {listField.label}
                    //                     </Label>
                    //                     <hr style={{ marginTop: '5px', marginBottom: '15px', borderTop: '1px solid #ddd' }} />
                    //                 </div>
                    //                 {listField.helptext ? <Label className="smLabl-txt">{listField.helptext}</Label> : ""}
                    //             </Col>
                    //         </Row>
                    //     );
                    } else if (listFieldRenderType == "url") {
                        multiInputElements.push(
                            <Row style={{ display: displayField }}>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }
                                        >
                                            <Input
                                                type="url"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error">
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldRenderType === "enum") {
                        let selectOptions;
                        let isLoadingOptions = false;
                        const isMultiSelect = (listFieldOriginalType === "cat_array");

                        if (listField.source === "parent_lookup") {
                            const lookupFieldName = listField.lookup_field;
                            const lookupFieldValue = multiInputValue(key, lookupFieldName);
                            const lookupFieldSchema = multiInputFields[0][lookupFieldName];
                            const selectedLookupOption = lookupFieldSchema.type_items.find(opt => opt.value === lookupFieldValue);

                            if (selectedLookupOption && selectedLookupOption.parent_source) {
                                const sourceKey = selectedLookupOption.parent_source;
                                selectOptions = props[sourceKey] || [];
                            } else {
                                selectOptions = [];
                            }
                        } else if (listField.source === "child_lookup") {
                            const lookupFieldName = listField.lookup_field; // e.g., "type"
                            const lookupFieldValue = multiInputValue(key, lookupFieldName);
                            const lookupFieldSchema = multiInputFields[0][lookupFieldName];
                            const selectedLookupOption = lookupFieldSchema.type_items.find(opt => opt.value === lookupFieldValue);

                            if (selectedLookupOption && selectedLookupOption.child_source) {
                                const childSourceKey = selectedLookupOption.child_source; // e.g., "taxonomyCategoryLookup"
                                const childLookupMap = props[childSourceKey]; // e.g., props.taxonomyCategoryLookup

                                if (childLookupMap) {
                                    const sourceFieldName = listField.source_field; // e.g., "parent"
                                    const sourceFieldValue = multiInputValue(key, sourceFieldName);
                                    selectOptions = childLookupMap[sourceFieldValue] || [];
                                } else {
                                    selectOptions = [];
                                }
                            } else {
                                selectOptions = [];
                            }
                        } else if (listFieldOriginalType === "resource_list") {
                            selectOptions = (props.resourceList && props.resourceList[listField.name])
                                ? [
                                    { value: "", label: "Empty" },
                                    ...props.resourceList[listField.name].map(item => ({
                                        value: item.key,
                                        label: item.label
                                    }))
                                ] : [];
                            isLoadingOptions = props.isLoadingResources;
                        } else if (listField.source === "category_list") {
                            selectOptions = props.categories;
                        } else if (listField.source === "project_list") {
                            selectOptions = props.projects;
                        } else {
                            selectOptions = listField.type_items || [];
                        }

                        // Common rendering for single and multi-select enums
                        multiInputElements.push(
                            <Row style={{ display: displayField }}>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }
                                        >
                                            {isMultiSelect ? (
                                                <SortableSelect
                                                    useDragHandle
                                                    axis="xy"
                                                    onSortEnd={onNestedMultiSelectSortEnd(listFieldId)}
                                                    distance={4}
                                                    getHelperDimensions={({ node }) => node.getBoundingClientRect()}
                                                    className="react-select primary"
                                                    classNamePrefix="react-select"
                                                    name={listFieldName}
                                                    value={multiInputMultiEnumValue(key, fieldkey, selectOptions)}
                                                    isMulti={true}
                                                    hideSelectedOptions={false}
                                                    options={selectOptions}
                                                    isLoading={isLoadingOptions}
                                                    isDisabled={isLoadingOptions}
                                                    onChange={(value) => handleMultiValueMultiEnumChange(listFieldId, value, listField)}
                                                    components={{
                                                        MultiValue: SortableMultiValue,
                                                        MultiValueLabel: SortableMultiValueLabel,
                                                    }}
                                                    allowSelectAll={true}
                                                    closeMenuOnSelect={false}
                                                    cropWithEllipsis={true}
                                                />
                                            ) : (
                                                <Select
                                                    className="react-select primary"
                                                    classNamePrefix="react-select"
                                                    name={listFieldName}
                                                    value={multiInputEnumValue(key, fieldkey, selectOptions)}
                                                    options={selectOptions}
                                                    isLoading={isLoadingOptions}
                                                    isDisabled={isLoadingOptions}
                                                    onChange={(value) => handleMultiValueEnumChange(listFieldId, value, listField)}
                                                />
                                            )}
                                            <br></br>
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error">
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                            <div id={listFieldId} tabIndex="0"></div>
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldRenderType == "file_upload") {
                        multiInputElements.push(
                            <Row style={{ display: displayField }}>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">
                                            {listField.label}
                                            {listField.size ? (
                                                <span>
                                                    ({listField.size})
                                                </span>
                                            ) : (
                                                ""
                                            )}{listField.required ? <span class="text-danger"> * </span> : ''}
                                        </Label>
                                    </div>
                                </Col>
                                <Col sm="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }
                                        >
                                            <ImageUpload
                                                projectId={props.projectId}
                                                imageDetails={listField}
                                                elementValue={
                                                    props.currentTabConfig
                                                        ? multiInputValue(
                                                            key,
                                                            fieldkey
                                                        )
                                                        : ""
                                                }
                                                id={listFieldId}
                                                handleEnumChange={(id, image) => handleMultiImageChange(listFieldId, image, fieldkey)}
                                            />
                                            <Input
                                                type="hidden"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error">
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldRenderType == "html") {
                        multiInputElements.push(
                            <Row>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col sm="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }>
                                            <textarea
                                                type="textarea"
                                                className="txtarea"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error" id={props.parent + listFieldId}>
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else if (listFieldRenderType == "tag-input") {
                        // New: tag-input inside a multi-input element
                        const tags = multiInputValue(key, fieldkey) || [];

                        const tagContainerStyle = {
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            gap: '5px',
                            padding: '0.375rem 0.75rem',
                            border: '1px solid #cad1d7',
                            borderRadius: '.25rem',
                            backgroundColor: '#fff',
                        };

                        const tagItemStyle = {
                            backgroundColor: '#007bff',
                            color: 'white',
                            borderRadius: '4px',
                            padding: '0.25em 0.6em',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '85%',
                            fontWeight: '700',
                            lineHeight: '1',
                            margin: '2px'
                        };

                        const tagRemoveStyle = {
                            marginLeft: '8px',
                            cursor: 'pointer',
                            border: 'none',
                            background: 'none',
                            padding: '0',
                            fontWeight: 'bold',
                            fontSize: '1.2em',
                            lineHeight: '1',
                            color: 'white',
                            opacity: '0.7',
                        };

                        multiInputElements.push(
                            <Row style={{ display: displayField }}>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col md="6">
                                    <div className="inptFom">
                                        <FormGroup className={props.fieldStates["error_" + listFieldId]}>
                                            <div style={tagContainerStyle}>
                                                {tags.map((tag, idx) => (
                                                    <div key={idx} style={tagItemStyle}>
                                                        {tag}
                                                        <button type="button" style={tagRemoveStyle} onClick={() => handleMultiRemoveTag(listFieldId, idx)}>&times;</button>
                                                    </div>
                                                ))}
                                                <Input
                                                    type="text"
                                                    value={multiTagInputs[listFieldId] || ''}
                                                    onChange={(e) => setMultiTagInputs(prev => ({ ...prev, [listFieldId]: e.target.value }))}
                                                    onKeyDown={(e) => handleMultiTagInputKeyDown(e, listFieldId, listField)}
                                                    placeholder="Add a tag and press Enter"
                                                    className="border-0"
                                                    style={{ boxShadow: 'none', flex: 1, minWidth: '120px' }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    } else {
                        multiInputElements.push(
                            <Row style={{ display: displayField }}>
                                <Col md="6">
                                    <div className="designLabel">
                                        <Label className="smLabl-txt">{listField.label}{listField.required ? <span class="text-danger"> * </span> : ''}</Label>
                                    </div>
                                </Col>
                                <Col sm="6">
                                    <div className="inptFom">
                                        <FormGroup
                                            className={
                                                props.fieldStates[
                                                "error_" + listFieldId
                                                ]
                                            }
                                        >
                                            <Input
                                                type="text"
                                                name={listFieldName}
                                                id={listFieldId}
                                                value={multiInputValue(
                                                    key,
                                                    fieldkey
                                                )}
                                                onChange={(event) =>
                                                    handleMultiValueChange(
                                                        listFieldId,
                                                        event,
                                                        listField
                                                    )
                                                }
                                            />
                                            {props.fieldStates[
                                                "error_" + listFieldId
                                            ] === "has-danger" ? (
                                                <label className="error">
                                                    {
                                                        props.fieldStates[
                                                        "error_message_" +
                                                        listFieldId
                                                        ]
                                                    }
                                                </label>
                                            ) : null}
                                        </FormGroup>
                                    </div>
                                </Col>
                            </Row>
                        );
                    }
                });

                let removeIndex = nextIndex + 1;
                multiInputElements.push(
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <Button
                            className="btn-smb"
                            type="button"
                            onClick={() => duplicateMultiInputValueElement(key)}
                        >
                            Duplicate
                        </Button>
                        <Button
                            className="btn-smb btnRd"
                            type="button"
                            onClick={(value) => removeMultiInputValueElement(removeIndex)}
                        >
                            Remove
                        </Button>
                    </div>
                );

                let accordionTitle = `${nextIndex + 1}`;
                if (elementDesign.action_key_field) {
                    const actionKeyFieldValue = multiInputValue(key, elementDesign.action_key_field);
                    if (actionKeyFieldValue) {
                        const actionKeyFieldSchema = multiInputFields[0][elementDesign.action_key_field];
                        const selectedOption = actionKeyFieldSchema.type_items.find(opt => opt.value === actionKeyFieldValue);

                        const titleValue = selectedOption ? selectedOption.label : actionKeyFieldValue;
                        accordionTitle += ` - ${titleValue}`;

                        if (selectedOption && selectedOption.key_field) {
                            const secondaryKeyFieldName = selectedOption.key_field;
                            const secondaryValue = multiInputValue(key, secondaryKeyFieldName);

                            if (secondaryValue) {
                                const secondaryFieldSchema = multiInputFields[0][secondaryKeyFieldName];
                                let displayValue = secondaryValue;

                                if (secondaryFieldSchema && secondaryFieldSchema.source === 'category_list' && props.categories) {
                                    const category = props.categories.find(cat => cat.value === String(secondaryValue));
                                    if (category && category.label) {
                                        displayValue = category.label;
                                    }
                                }
                                accordionTitle += ` - ${displayValue}`;
                            }
                        }
                    }
                }

                divElements.push(
                    <SortableChildDiv key={nextIndex} index={nextIndex} >
                        <Accordion preExpanded={[totalValues.length - 1]} allowZeroExpanded >
                            <AccordionItem key={nextIndex} uuid={nextIndex}>
                                <AccordionItemHeading>
                                    <AccordionItemButton>
                                        <div id="reorder-column" style={{ float: "left", marginRight: "15px" }}>
                                            <DragHandle />
                                        </div>
                                        {accordionTitle}
                                    </AccordionItemButton>
                                </AccordionItemHeading>
                                <AccordionItemPanel>
                                    {multiInputElements}
                                </AccordionItemPanel>
                            </AccordionItem>
                        </Accordion>
                    </SortableChildDiv>
                )
                nextIndex++;
                //})
            }
        }

        element.push(
            <Row style={{ display: displayField }}> 
                <Col md="12">
                    <Label className="subHeading_h4">
                        <b>{elementDesign.label}</b>
                    </Label>
                </Col>
                <Col md="12">
                    <SortableParentDiv useDragHandle
                        onSortEnd={onSortEnd}
                        // pressDelay={200} 
                        axis="xy"
                    // shouldCancelStart={shouldCancelStart}
                    >
                        <div id={elementId}>
                            {divElements}

                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error" style={{ color: '#FFC0A4' }}>
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }

                                </label>
                            ) : null}

                        </div>
                    </SortableParentDiv>
                </Col>
                <Col md="8">
                    <div className="dflLft">
                        <Button
                            className="btn-smb"
                            type="button"
                            onClick={(value) =>
                                addMultiInputValueElement(nextIndex, defaultElement)
                            }>
                            Add More
                        </Button>
                    </div>

                    {/* {nextIndex>1?<Button
          className="btn-round"
          color="danger"
          type="button"
          onClick={(value)=>removeMultiInputValueElement(nextIndex) }
        >Remove</Button>:''} */}
                </Col>
            </Row>
        );
    } else if (elementType == "multi-input-object") {
        const currentObjectValue = currentValue() || {};
        const itemSchema = elementDesign.type_items;
        const actionKeyField = elementDesign.action_key_field;

        divElements = Object.keys(currentObjectValue).map((objectKey, index) => {
            const objectItem = currentObjectValue[objectKey];
            let innerFormElements = [];

            const renderFields = (schema, basePathArray, parentElements) => {
                Object.keys(schema).forEach((key) => {
                    const config = schema[key];
                    const currentPathArray = [...basePathArray, key];
                    const fieldId = `${elementId}:${objectKey}:${currentPathArray.join(':')}`;

                    if (config.items && typeof config.items === 'object' && !Array.isArray(config.items)) {
                        // Nested group
                        parentElements.push(
                            <Row key={`${fieldId}-groupHeader`}>
                                <Col md="12">
                                    <Label className="subHeading_h4_small"><b>{config.label}</b></Label>
                                    {config.helptext && <p className="smLabl-txt">{config.helptext}</p>}
                                    <hr />
                                </Col>
                            </Row>
                        );
                        renderFields(config.items, currentPathArray, parentElements); // Recursive call
                    } else {
                        // Direct field
                        const fieldValue = multiObjectInputValue(objectKey, currentPathArray);
                        let showField = true;
                        if (config.parent_field && typeof config.parent_field === 'object') {
                            for (let pfKey in config.parent_field) {
                                // Assuming parent_field refers to a field at the same level or one level up in the current object item
                                let actualParentValue;
                                // Try to resolve pfKey as a sibling within the current group first
                                actualParentValue = multiObjectInputValue(objectKey, [...basePathArray, pfKey]);

                                if (actualParentValue === undefined) {
                                    // If not found as a sibling, try resolving as a top-level field in the item
                                    // This covers cases where a nested field depends on a root-level field of the multi-input-object item.
                                    actualParentValue = multiObjectInputValue(objectKey, [pfKey]);
                                }

                                const allowedValues = config.parent_field[pfKey];
                                if (!allowedValues.includes(actualParentValue)) {
                                    showField = false;
                                    break;
                                }
                            }
                        }
                        let displayField = showField ? '' : 'none';
                        if (config.type === "string" || config.type === "url" || config.type === "integer") {
                            parentElements.push(
                                <Row key={fieldId} style={{ display: displayField }}>
                                    <Col md="6"><Label className="smLabl-txt">{config.label}{config.required ? <span className="text-danger"> * </span> : ''}</Label></Col>
                                    <Col md="6">
                                        <FormGroup className={props.fieldStates["error_" + fieldId]}>
                                            <Input type={config.type === "integer" ? "number" : "text"} id={fieldId} value={fieldValue} onChange={(e) => handleMultiObjectValueChange(fieldId, e, config)} />
                                            {props.fieldStates["error_" + fieldId] === "has-danger" && <label className="error">{props.fieldStates["error_message_" + fieldId]}</label>}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            );
                        } else if (config.type === "boolean") {
                            parentElements.push(
                                <Row key={fieldId} style={{ display: displayField }}>
                                    <Col md="6"><Label className="smLabl-txt">{config.label}{config.required ? <span className="text-danger"> * </span> : ''}</Label></Col>
                                    <Col md="6">
                                        <Switch offColor="success" offText={<i className="nc-icon nc-simple-remove" />} onColor="success" onText={<i className="nc-icon nc-check-2" />} value={fieldValue} onChange={(_, enabled) => handleMultiObjectValueEnumChange(fieldId, { value: enabled }, config)} />
                                    </Col>
                                </Row>
                            );
                        } else if (config.type === "enum") {
                            const isMulti = config.is_multi === true || config.multiple === true || config.type_mode === "multi";
                            parentElements.push(
                                <Row key={fieldId} style={{ display: displayField }}>
                                    <Col md="6"><Label className="smLabl-txt">{config.label}{config.required ? <span className="text-danger"> * </span> : ''}</Label></Col>
                                    <Col md="6">
                                        <FormGroup className={props.fieldStates["error_" + fieldId]}>
                                            {isMulti ? (
                                                <SortableSelect
                                                    useDragHandle
                                                    axis="xy"
                                                    onSortEnd={onObjectMultiSelectSortEnd(fieldId)}
                                                    distance={4}
                                                    getHelperDimensions={({ node }) => node.getBoundingClientRect()}
                                                    className="react-select primary"
                                                    classNamePrefix="react-select"
                                                    value={multiObjectInputMultiEnumValue(objectKey, currentPathArray, config.type_items)}
                                                    options={config.type_items}
                                                    isMulti={true}
                                                    hideSelectedOptions={false}
                                                    onChange={(val) => handleMultiObjectValueMultiEnumChange(fieldId, val, config)}
                                                    components={{
                                                        MultiValue: SortableMultiValue,
                                                        MultiValueLabel: SortableMultiValueLabel,
                                                    }}
                                                    allowSelectAll={true}
                                                    closeMenuOnSelect={false}
                                                />
                                            ) : (
                                                <Select className="react-select primary" classNamePrefix="react-select" value={multiObjectInputEnumValue(objectKey, currentPathArray, config.type_items)} options={config.type_items} onChange={(val) => handleMultiObjectValueEnumChange(fieldId, val, config)} />
                                            )}
                                            {props.fieldStates["error_" + fieldId] === "has-danger" && <label className="error">{props.fieldStates["error_message_" + fieldId]}</label>}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            );
                        } else if (config.type === "hex_color") {
                            parentElements.push(
                                <Row key={fieldId} style={{ display: displayField }}>
                                    <Col md="6"><Label className="smLabl-txt">{config.label}{config.required ? <span className="text-danger"> * </span> : ''}</Label></Col>
                                    <Col md="6">
                                        <div className="inptFomColr">
                                            <div className="clrChng" style={{ display: "inline-block", border: "none", }}>
                                                <Input style={{ background: fieldValue }} type="color" id={fieldId} value={fieldValue} onChange={(e) => handleMultiObjectValueChange(fieldId, e, config)} />
                                            </div>
                                            <div className="clrTxt" style={{ display: "inline-block" }}>
                                                <input type="text" id={`${fieldId}-text`} value={fieldValue} onChange={(e) => handleMultiObjectValueChange(fieldId, e, config)} />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            );
                        } else if (config.type === "file_upload") {
                            parentElements.push(
                                <Row key={fieldId} style={{ display: displayField }}>
                                    <Col md="6"><Label className="smLabl-txt">{config.label} {config.size ? `(${config.size})` : ""}{config.required ? <span className="text-danger"> * </span> : ''}</Label></Col>
                                    <Col md="6">
                                        <ImageUpload projectId={props.projectId} imageDetails={config} elementValue={fieldValue} id={fieldId} handleEnumChange={(id, image) => handleMultiObjectValueEnumChange(id, image, config)} />
                                        {props.fieldStates["error_" + fieldId] === "has-danger" && <label className="error">{props.fieldStates["error_message_" + fieldId]}</label>}
                                    </Col>
                                </Row>
                            );
                        }
                        // Add other types as needed (html, textarea, etc.)
                    }
                });
            };


            renderFields(itemSchema, [], innerFormElements);

            return (
                <AccordionItem key={objectKey} uuid={objectKey}>
                    <AccordionItemHeading>
                        <AccordionItemButton>
                            {objectItem[actionKeyField] || objectKey}
                        </AccordionItemButton>
                    </AccordionItemHeading>
                    <AccordionItemPanel>
                        {innerFormElements}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                            <Button
                                className="btn-smb"
                                type="button"
                                onClick={() => duplicateMultiInputObjectValueElement(objectKey)}
                            >
                                Duplicate
                            </Button>
                            <Button
                                className="btn-smb btnRd" type="button" onClick={() => removeMultiInputObjectValueElement(objectKey)}>Remove</Button>
                        </div>                    </AccordionItemPanel>
                </AccordionItem>
            );
        });

        element.push(
            <Row key={elementId + "-multi-object-row"}>
                <Col md="12">
                    <Label className="subHeading_h4"><b>{elementDesign.label}</b></Label>
                    {helpText && <p className="smLabl-txt">{helpText}</p>}
                </Col>
                <Col md="12">
                    <Accordion allowZeroExpanded preExpanded={[]}>
                        {divElements}
                    </Accordion>
                </Col>
                {props.fieldStates["error_" + elementId] === "has-danger" && (
                    <Col md="12"> {/* Ensure error message spans full width or adjust as needed */}
                        <label className="error" style={{ color: 'red', textAlign: 'left', display: 'block' }}>
                            {props.fieldStates["error_message_" + elementId]}
                        </label>
                    </Col>)}
                <Col md="12" className="mt-2">
                    <Row>
                        <Col md="4">
                            <Input
                                type="text"
                                placeholder={`New ${elementDesign.action_key_field || 'Key'}`}
                                value={newObjectKey}
                                onChange={(e) => setNewObjectKey(e.target.value)}
                            />
                        </Col>
                        <Col md="4">
                            <Button
                                className="btn-smb"
                                type="button"
                                onClick={addMultiInputObjectValueElement}
                            >
                                Add New {elementDesign.labelSingular || 'Item'}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );

    } else if (elementType == "json") {
        element.push(
            <>
                <Row>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>

                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup
                                className={props.fieldStates["error_" + elementId]}>
                                <textarea
                                    type="textarea"
                                    className="txtarea"
                                    name={elementName}
                                    id={elementId}
                                    rows={8}
                                    style={{ fontFamily: 'monospace' }}
                                    value={currentValue()}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </FormGroup>
                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error" id={props.parent + elementId}>
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }
                                </label>
                            ) : null}
                        </div>
                    </Col>
                </Row>
            </>
        );
    } else if (elementType == "html") {
        element.push(
            <>
                <Row>
                    <Col sm="6">
                        <div className="designLabel">
                            <small className="text-default">
                                {elementDesign.label}
                            </small>
                        </div>
                        {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                    </Col>

                    <Col sm="6">
                        <div className="inptFom1">
                            <FormGroup
                                className={props.fieldStates["error_" + elementId]}>
                                <textarea
                                    type="textarea"
                                    className="txtarea"
                                    name={elementName}
                                    id={elementId}
                                    value={currentValue()}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                            </FormGroup>
                            {props.fieldStates["error_" + elementId] ===
                                "has-danger" ? (
                                <label className="error" id={props.parent + elementId}>
                                    {
                                        props.fieldStates[
                                        "error_message_" + elementId
                                        ]
                                    }
                                </label>
                            ) : null}
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
    else if (elementType == "tag-input") {
        const tags = currentValue() || [];
        const tagContainerStyle = {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: '5px',
            padding: '0.375rem 0.75rem',
            border: '1px solid #cad1d7',
            borderRadius: '.25rem',
            backgroundColor: '#fff',
        };

        const tagItemStyle = {
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '4px',
            padding: '0.25em 0.6em',
            display: 'flex',
            alignItems: 'center',
            fontSize: '85%',
            fontWeight: '700',
            lineHeight: '1',
            textAlign: 'center',
            whiteSpace: 'nowrap',
            verticalAlign: 'baseline',
            margin: '2px'
        };

        const tagRemoveStyle = {
            marginLeft: '8px',
            cursor: 'pointer',
            border: 'none',
            background: 'none',
            padding: '0',
            fontWeight: 'bold',
            fontSize: '1.2em',
            lineHeight: '1',
            color: 'white',
            opacity: '0.7',
        };

        element.push(
            <Row>
                <Col sm="6">
                    <div className="designLabel">
                        <small className="text-default">
                            {elementDesign.label}{props.data.required ? <span className="text-danger"> * </span> : ""}
                        </small>
                    </div>
                    {helpText !== "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                </Col>
                <Col sm="6">
                    <div className="inptFom1">
                        <div style={tagContainerStyle}>
                            {tags.map((tag, index) => (
                                <div key={index} style={tagItemStyle}>
                                    {tag}
                                    <button type="button" style={tagRemoveStyle} onClick={() => handleRemoveTag(index)}>&times;</button>
                                </div>
                            ))}
                            <Input
                                type="text"
                                value={tagInput}
                                onChange={(e) => setTagInput(e.target.value)}
                                onKeyDown={handleTagInputKeyDown}
                                placeholder="Add a tag and press Enter"
                                className="border-0"
                                style={{ boxShadow: 'none', flex: 1, minWidth: '120px' }}
                            />
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }
    else {
        element.push(
            <Row>
                <Col sm="6">
                    <div className="designLabel">
                        <small className="text-default">
                            {elementDesign.label}
                        </small>
                    </div>
                    {helpText != "" ? <Label className="smLabl-txt">{helpText}</Label> : ""}
                </Col>

                <Col sm="6">
                    <div className="inptFom1">
                        <FormGroup
                            className={props.fieldStates["error_" + elementId]}
                        >
                            <Input
                                type="text"
                                name={elementName}
                                id={elementId}
                                value={currentValue()}
                                onChange={handleChange}
                                onBlur={handleBlur}
                            />
                        </FormGroup>
                        {props.fieldStates["error_" + elementId] ===
                            "has-danger" ? (
                            <label className="error">
                                {props.fieldStates["error_message_" + elementId]}
                            </label>
                        ) : null}
                    </div>
                </Col>
            </Row>
        );
    }

    return (
        <div className="container">
            <ReactTooltip
                place="top"
                border="true"
                effect="solid"
                type="light"
                html={true}
            />
            {element}
        </div>
    );
};

export default ConfigFormComponent;
